import { useEffect } from 'react';

const HUBSPOT_CONTAINER_ID = 'hubspot-messages-iframe-container';

/**
 * Like useHideHubSpotChat, but also sets pointer-events: none on the HubSpot
 * container after removal. This prevents the invisible container from blocking
 * pointer events on content beneath it (e.g. buttons near the bottom of the viewport).
 */
const useHideHubSpotChatWithPointerFix = (shouldHideChat: boolean) => {
    useEffect(() => {
        const container = document.getElementById(HUBSPOT_CONTAINER_ID);

        if (shouldHideChat) {
            if (window.HubSpotConversations && window.HubSpotConversations.widget) {
                window.HubSpotConversations.widget.remove();
            }
            if (container) {
                container.style.pointerEvents = 'none';
            }
        } else {
            if (container) {
                container.style.pointerEvents = '';
            }
            if (window.HubSpotConversations && window.HubSpotConversations.widget && window.innerWidth > 768) {
                // On mobile the bubble is intentionally hidden — never auto-reload it
                window.HubSpotConversations.widget.load();
            }
        }
    }, [shouldHideChat]);
};

export default useHideHubSpotChatWithPointerFix;
